import React, { useEffect, useState } from "react";
import ModalContainer from "../../components/ModalContainer.jsx";
import { Form, Formik } from "formik";
import GetField from "../../components/GetField.jsx";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import {
  initialTouched,
  initialValues,
  onSubmit,
  validationSchema,
} from "./orderStatusFormikCodes.js";
import { getSingleOrderService } from "../../services/ordersServices.js";
import Alert from "../../utils/Alert.js";

const options = [
  {
    text: "جاری",
    value: "o",
  },
  {
    text: "تکمیل شده",
    value: "d",
  },
  {
    text: "لغو شده",
    value: "c",
  },
];

const OrderStatus = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [reinitializeValues, setReinitializeValues] = useState(null);

  const location = useLocation();

  const navigate = useNavigate();

  const { setData } = useOutletContext();

  const handleGetOrderData = async (orderCode) => {
    try {
      const response = await getSingleOrderService(orderCode);
      if (response.status === 200) {
        setEditingOrder(response.data);
      }
    } catch (error) {
      Alert(
        `خطا ${error.response?.status || ""}!`,
        "در دریافت جزئیات سفارش مشکلی رخ داده است!\nلطفاً مجدداً تلاش کنید.",
        "error"
      );
      return navigate(-1);
    } finally {
    }
  };

  useEffect(() => {
    if (location.state) {
      handleGetOrderData(location.state.code);
    } else {
      return navigate(-1);
    }
  }, []);

  useEffect(() => {
    if (editingOrder) {
      setReinitializeValues({
        status: editingOrder.status,
        transfer_price: editingOrder.transfer_price,
        tax: editingOrder.tax,
        discount_code: editingOrder.discount_code,
        isPaid: location.state.is_paid,
      });
    } else {
      setReinitializeValues(null);
    }
  }, [editingOrder]);

  return (
    <ModalContainer
      alwaysOpen={true}
      fullscreen={false}
      title={`تغییر وضعیت سفارش ${location.state?.code}`}
      className="max-w-screen-sm"
    >
      {location.state?.status && (
        <h3 className="mb-6 text-primary">
          آخرین وضعیت ثبت شده: &nbsp;
          <span className="font-bold">
            {location.state.status === "o"
              ? "جاری"
              : location.state.status === "d"
              ? "تکمیل شده"
              : location.state.status === "c" && "لغو شده"}
          </span>
        </h3>
      )}
      <Formik
        initialValues={reinitializeValues || initialValues}
        initialTouched={reinitializeValues ? initialTouched : {}}
        onSubmit={(values, actions) =>
          onSubmit(values, actions, editingOrder, setData, navigate)
        }
        validationSchema={validationSchema}
        enableReinitialize
        validateOnMount
      >
        {(formik) => {
          return (
            <Form className="flex flex-col">
              <div className="w-full sm:w-3/4 mb-4">
                <GetField
                  control="select"
                  name="status"
                  options={options}
                  label="وضعیت سفارش:"
                  title="وضعیت سفارش را انتخاب کنید"
                  formik={formik}
                />
              </div>
              <div>
                <div className="w-full sm:w-3/4 mb-4">
                  <GetField
                    control="input"
                    name="transfer_price"
                    type="text"
                    placeholder="هزینه ارسال"
                    label="هزینه ارسال"
                    formik={formik}
                  />
                </div>

                <div className="w-full sm:w-3/4 mb-4">
                  <GetField
                    control="input"
                    name="tax"
                    type="text"
                    placeholder="مالیات"
                    label="مالیات"
                    formik={formik}
                  />
                </div>

                <div className="w-full sm:w-3/4 mb-4">
                  <GetField
                    control="input"
                    name="discount_code"
                    type="text"
                    placeholder="کد تخفیف"
                    label="کد تخفیف"
                    formik={formik}
                  />
                </div>

              </div>
              <div className="w-full mt-2">
                <GetField
                  control="submitbutton"
                  disabledButton={true}
                  formik={formik}
                  text="تغییر وضعیت"
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </ModalContainer>
  );
};

export default OrderStatus;
